'use es6';

export default {
  get isMac() {
    return /Mac/.test(window.navigator.platform) || /Macintosh/.test(window.navigator.userAgent);
  },

  get isWindows() {
    return !this.isMac;
  }

};